import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BookOpen, FolderOpen, ClipboardList, Star } from "lucide-react";

import {
  Button,
  List,
  Progress,
  message,
  Spin,
  Modal,
  Divider,
  Tabs,
  Select,
  Tooltip,
} from "antd";
import {
  EditOutlined,
  LoadingOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  WhatsAppOutlined,
  HeartOutlined,
} from "@ant-design/icons";

import Plyr from "plyr-react";
// import "plyr-react/dist/plyr.css";
import "plyr/dist/plyr.css";
import 'react-quill/dist/quill.bubble.css';

// API
import {
  addCourseToWishList,
  buyACourse,
  enrollToCourseContent,
  getAllUsersOfACourse,
  getCourseById,
  getCourseContentByRoleAndCourseId,
  getUsersCourses,
  editCourse,
  getAllUsers,
} from "../../../../Constants/Api/functions/function";

import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

import nodata from "../../../../Assets/Images/nodata.png";
import video from "../../../../Assets/Images/video.png";
import files from "../../../../Assets/Images/file.png";
import free from "../../../../Assets/Images/free.png";

import "./style.scss";
import CourseUsers from "./CourseUsers";
import { setUsersCources } from "../../../../Reducers/usersCourcesReducer";

import buyImage from "../../../../Assets/Images/buynow.png";
import CourseAssessments from "./CourseAssessments";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import BookReader from "./BookReader";

const parseDurationToSeconds = (durationStr) => {
  if (!durationStr || typeof durationStr !== 'string') return 0;
  const parts = durationStr.split(':').map(Number);
  if (parts.some(isNaN)) return 0;

  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  } else if (parts.length === 2) {
    return parts[0] * 60 + parts[1];
  }
  return 0;
};

const formatTotalDuration = (totalSeconds) => {
  if (!totalSeconds || isNaN(totalSeconds)) return "0 mins";
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);

  if (hrs > 0) {
    return `${hrs} ${hrs === 1 ? 'hr' : 'hrs'} ${mins} ${mins === 1 ? 'min' : 'mins'}`;
  }
  return `${mins} ${mins === 1 ? 'min' : 'mins'}`;
};

const Course = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isEnrollLoading, setIsEnrollLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const courseId = useParams().id;
  const [selectedContentId, setSelectedContentId] = useState();
  const [courseContents, setCourseContents] = useState();
  const [completedPercentage, setCompletedPercentage] = useState(0);
  const [data, setData] = useState();
  const [course, setCourse] = useState();
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const allCources = useSelector((state) => state.allCources.allCources);

  const totalDuration = useMemo(() => {
    if (!courseContents || !courseContents.length) return "0 mins";
    const totalSeconds = courseContents.reduce((acc, curr) => {
      return acc + parseDurationToSeconds(curr.duration);
    }, 0);
    return formatTotalDuration(totalSeconds);
  }, [courseContents]);
  const usersCources = useSelector((state) => state.usersCources.usersCources);
  const [userCources, setUserCources] = useState();
  const [isCourseUnlocked, setIsCourseUnlocked] = useState(false);
  const [isContentUnlocked, setIsContentUnlocked] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [courseUsers, setCourseusers] = useState(null);
  const [openCourseUsers, setOpenCourseUsers] = useState(false);
  const [showEntrollPopupForFreeCourse, setShowEntrollPopupForFreeCourse] =
    useState(false);
  const [showEntrollPopupForPaidCources, setShowEntrollPopupForPaidCources] =
    useState(false);
  const [showLockedContentPrompt, setShowLockedContentPrompt] = useState(false);
  const [isLessonDescriptionExpanded, setIsLessonDescriptionExpanded] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedCoordinatorId, setSelectedCoordinatorId] = useState(undefined);
  const [coordinators, setCoordinators] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [isAssigning, setIsAssigning] = useState(false);

  const isAssignedInstructor = userProfile?.role === "instructor" && userProfile?.id && (String(course?.instructorId) === String(userProfile.id) || (course?.instructorIds && course.instructorIds.includes(userProfile.id)));
  const isCoordinator = userProfile?.role === "coordinator" && course?.coordinatorId && userProfile?.id && String(course.coordinatorId) === String(userProfile.id);
  const isSuperAdmin = userProfile?.role === "superadmin" || userProfile?.role === "admin" || isAssignedInstructor || isCoordinator;

  useEffect(() => {
    if (userProfile && course) {
      if (userProfile.role === "coordinator") {
        if (!course.coordinatorId || !userProfile.id || String(course.coordinatorId) !== String(userProfile.id)) {
          history.push("/dashboard/cources");
        }
      }
    }
  }, [userProfile, course, history]);

  useEffect(() => {
    if (allCources) {
      setCourse(allCources.find((item) => item.id === courseId));
    } else {
      handleGetCourse();
    }
  }, [allCources]);

  useEffect(() => {
    const fetchUsers = async () => {
      if (userProfile?.role === "superadmin" || userProfile?.role === "admin") {
        try {
          const users = await getAllUsers(1); // Center 1
          if (users) {
            const filteredCoordinators = users.filter((u) => u.role === "coordinator");
            setCoordinators(filteredCoordinators);
            const filteredInstructors = users.filter((u) => u.role === "instructor");
            setInstructors(filteredInstructors);
          }
        } catch (error) {
          console.error("Failed fetching users:", error);
        }
      }
    };
    fetchUsers();
  }, [userProfile]);

  const handleAssignCoordinator = async () => {
    setIsAssigning(true);
    try {
      const selectedCoord = coordinators.find((c) => c.id === selectedCoordinatorId);
      const response = await editCourse({
        id: courseId,
        coordinatorId: selectedCoordinatorId || null,
        coordinatorName: selectedCoord ? selectedCoord.name : null,
        coordinatorWhatsApp: selectedCoord ? selectedCoord.contactNumber : null,
      });
      if (response && response.status === 200) {
        openMessage("success", "Coordinator assigned successfully");
        setShowAssignModal(false);
        await handleGetCourse();
      } else {
        openMessage("error", "Failed to assign coordinator");
      }
    } catch (error) {
      console.error("handleAssignCoordinator error:", error);
      openMessage("error", "Failed to assign coordinator");
    } finally {
      setIsAssigning(false);
    }
  };

  useEffect(() => {
    if (userProfile?.role !== "superadmin" && userProfile?.role !== "admin") {
      if (usersCources) {
        setUserCources(usersCources);
      } else {
        handleGetUserCources();
      }
    }
  }, [usersCources]);

  useEffect(() => {
    if (isSuperAdmin) {
      setIsCourseUnlocked(true);
    }
  }, [isSuperAdmin]);

  useEffect(() => {
    if (userProfile?.role === "coordinator" || userProfile?.role === "superadmin" || userProfile?.role === "admin") {
      setShowEntrollPopupForFreeCourse(false);
      setShowEntrollPopupForPaidCources(false);
      return;
    }

    if (userCources && course) {
      const isCourseInUserCourses = userCources?.find(
        (item) => item.id === course.id
      );
      const lastVisit = localStorage.getItem("digital-academy-last-visit");
      if (lastVisit !== courseId) {
        if (!isCourseInUserCourses && course?.price === 0) {
          setShowEntrollPopupForFreeCourse(true);
        } else {
          setShowEntrollPopupForFreeCourse(false);
        }

        if (!isCourseInUserCourses && course?.price !== 0) {
          setShowEntrollPopupForPaidCources(true);
        } else {
          setShowEntrollPopupForPaidCources(false);
        }

        localStorage.removeItem("digital-academy-last-visit");
      } else {
        setShowEntrollPopupForFreeCourse(false);
        setShowEntrollPopupForPaidCources(false);
        localStorage.removeItem("digital-academy-last-visit");
      }
    }
  }, [userCources, course, userProfile]);

  // Derive whether the course is in user's courses
  const isCourseInUserCourses = userCources?.find(
    (item) => item.id === course?.id
  );

  const hasBookAccess = isSuperAdmin || (isCourseInUserCourses && (course?.price === 0 || !!isCourseInUserCourses?.isPaid));

  useEffect(() => {
    if (!courseContents) return;
    try {
      const userCourse = userCources?.find((item) => item.id === courseId);

      // Full course access: only when fully paid (or superadmin or coordinator or instructor)
      const hasFullAccess = isSuperAdmin || !!userCourse?.isPaid;

      if (hasFullAccess !== isCourseUnlocked) {
        setIsCourseUnlocked(hasFullAccess);
      }

      const content = courseContents.find(
        (item) => item.id === selectedContentId
      );

      // A single content is unlocked when:
      // - superadmin/staff, OR
      // - content is individually free, OR
      // - backend says hasAccess=1 (handles installments & enrollment)
      const unlocked =
        !!content &&
        (isSuperAdmin ||
          content?.isFree === 1 ||
          content?.isFree === true ||
          content?.hasAccess === 1 ||
          content?.hasAccess === true);

      setIsContentUnlocked(unlocked);
    } catch (error) {
      console.error("isContentUnlocked", error);
    }
  }, [
    courseContents,
    selectedContentId,
    userCources,
    course,
    courseId,
    userProfile,
    isCourseUnlocked,
  ]);

  useEffect(() => {
    if (userProfile) {
      getCourseContents();

      if (userProfile?.role === "superadmin" || userProfile?.role === "admin" || userProfile?.role === "coordinator" || userProfile?.role === "instructor") {
        getCourseUsers();
      }
    }
  }, [userProfile, course]);



  const handleGetUserCources = async () => {
    setIsLoading(true);
    try {
      const userCources = await getUsersCourses(userProfile?.id);

      setUserCources(userCources);
      dispatch(setUsersCources(userCources));
    } catch (error) {
      console.error("handleGetUserCources", error);
    }
    setIsLoading(false);
  };

  const handleGetCourse = async () => {
    setIsLoading(true);
    try {
      const response = await getCourseById(courseId);
      if (response) {
        setCourse(response);
      }
    } catch (error) {
      console.error("handleGetCourse", error);
    }
    setIsLoading(false);
  };

  const getCourseUsers = async () => {
    setIsLoadingUsers(true);
    const response = await getAllUsersOfACourse(courseId);
    setCourseusers(response);
    setIsLoadingUsers(false);
  };

  const getCourseContents = async () => {
    setIsLoading(true);
    try {
      let response = await getCourseContentByRoleAndCourseId(
        courseId,
        userProfile.role,
        userProfile.id
      );
      if (response) {
        setCourseContents(response);

        response.sort((a, b) => {
          return new Date(a.createdAt) - new Date(b.createdAt);
        });

        const completedContents = response.filter(
          (item) => item?.participation?.id
        );
        const percentage = response.length > 0 ? (completedContents.length / response.length) * 100 : 0;
        setCompletedPercentage(
          percentage % 1 === 0 ? percentage : percentage.toFixed(1)
        );

        setData(
          response.map((item, index) => {
            return {
              id: item.id,
              title: item.title,
              status: item?.participation?.id ? "completed" : "pending",
              duration: item.duration,
            };
          })
        );

        // Find first accessible content, or first content if none accessible
        const accessibleContent = response.find(
          (item) =>
            item?.hasAccess === 1 ||
            item?.hasAccess === true ||
            item?.isFree === 1
        );
        if (accessibleContent) {
          setSelectedContentId(accessibleContent.id);
        } else if (response[0]) {
          // If no accessible content, still select first one (will be locked/faded)
          setSelectedContentId(response[0].id);
        }
      }
    } catch (error) {
      console.error("getCourseContents", error);
    }
    setIsLoading(false);
  };

  const handleMarkAsLearned = async () => {
    setIsEnrollLoading(true);
    try {
      const response = await enrollToCourseContent(
        courseId,
        userProfile.id,
        selectedContentId
      );

      if (response && response.status === 200) {
        openMessage("success", "Marked as learned");
        getCourseContents();
      } else {
        openMessage("error", "Error occured while marking as learned");
      }
    } catch (error) {
      console.error("handleMarkAsLearned", error);
      openMessage("error", "Error occured while marking as learned");
    }
    setIsEnrollLoading(false);
  };

  const openMessage = (type, content) => {
    messageApi.open({
      type: type,
      content: content,
    });
  };

  const hnadleEnrollToFreeCourse = async () => {
    setIsLoading(true);
    try {
      const values = {
        courseId: courseId,
        userId: userProfile.id,
        isPaid: false,
        isAddToPayments: true,
      };

      const response = await buyACourse(values);

      if (response && response.status === 200) {
        openMessage("success", "You have successfully enrolled to this course");
        getCourseContents();
      } else {
        openMessage("error", "Error occured while enrolling to this course");
      }
    } catch (error) {
      console.error("hnadleEnrollToFreeCourse", error);
      openMessage("error", "Error occured while enrolling to this course");
    }
    setIsLoading(false);
    setShowEntrollPopupForFreeCourse(false);
  };

  const isCourseInWishList = () => {
    const userWishList = userProfile?.courseWishlist;
    const wishlistIds = userWishList?.split(",");
    wishlistIds?.pop();

    return wishlistIds?.includes(courseId);
  };

  const handleAddToWishList = async () => {
    setIsLoading(true);
    try {
      const response = await addCourseToWishList(userProfile.id, courseId);
      if (response) {
        openMessage("success", "Course added to wishlist");
      } else {
        openMessage("error", "Error occured while adding to wishlist");
      }
    } catch (error) {
      console.error("handleAddToWishList", error);
      openMessage("error", "Error occured while adding to wishlist");
    }

    setShowEntrollPopupForPaidCources(false);
    setIsLoading(false);
  };



  const handleContentSelect = (contentId, isLocked) => {
    // Prevent selecting locked content
    if (isLocked) {
      setShowLockedContentPrompt(true);
      return; // Don't change selected content if it's locked
    }
    setSelectedContentId(contentId);
    setIsLessonDescriptionExpanded(false);
    setShowLockedContentPrompt(false);
  };

  const isContentLockedForUser = (contentId) => {
    const content = courseContents?.find((item) => item.id === contentId);
    if (!content) return true; // Lock if content not found
    if (isSuperAdmin) return false; // Superadmin always has access

    // Free content is always accessible
    if (content?.isFree === 1 || content?.isFree === true) return false;

    // Backend access flag (handles enrollment + installments + free courses after enroll)
    if (content?.hasAccess === 1 || content?.hasAccess === true) return false;

    // Otherwise, lock it for students (item stays visible but faded/unclickable)
    return userProfile?.role === "student";
  };

  return (
    <div className="course">
      {contextHolder}
      <Modal
        title=""
        footer={null}
        centered
        open={showEntrollPopupForFreeCourse}
        onOk={() => setShowEntrollPopupForFreeCourse(false)}
        onCancel={() => setShowEntrollPopupForFreeCourse(false)}
      >
        <div className="confirmEnrollPopup">
          <div className="image">
            <img src={free} alt="Buy Course" />
          </div>
          <h1>{course?.type === 'book' ? "Get this book for free" : "Enroll to this course for free"}</h1>
          <p>
            {course?.type === 'book'
              ? "This book is free for you. You can get access to this book for free. Do you want to add this book to your library?"
              : "This course is free for you. You can enroll to this course for free. Do you want to enroll to this course?"}
          </p>
          <div className="actions">
            <Button
              type="primary"
              onClick={hnadleEnrollToFreeCourse}
              icon={isLoading ? <LoadingOutlined /> : null}
            >
              {course?.type === 'book' ? "Get Book" : "Enroll"}
            </Button>
            <Button
              type="default"
              onClick={() => setShowEntrollPopupForFreeCourse(false)}
            >
              Cancel
            </Button>
            {course?.whatsappGroupLink && (
              <a
                href={course?.whatsappGroupLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  type="primary"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#25d366",
                  }}
                >
                  <WhatsAppOutlined />
                  Join Whatsapp Group
                </Button>
              </a>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        className="paidCoursePopup"
        title=""
        footer={null}
        centered
        open={showEntrollPopupForPaidCources}
        onOk={() => setShowEntrollPopupForPaidCources(false)}
        onCancel={() => setShowEntrollPopupForPaidCources(false)}
      >
        <div className="confirmEnrollPopup">
          <div className="image">
            {course?.videoUrl && (
              <Plyr
                source={{
                  type: "video",
                  sources: [
                    {
                      src: course?.videoUrl,
                      provider: "youtube",
                    },
                  ],
                }}
              />
            )}
          </div>
          <h1>{course?.type === 'book' ? "Get this book" : "Enroll to this course"}</h1>
          {!isCourseInWishList() ? (
            <p>
              {course?.type === 'book'
                ? "You can read this book by buying it. Or you can add this book to your wishlist and buy it later."
                : "You can enroll to this course by buying it. Or you can add this course to your wishlist and buy it later."}
            </p>
          ) : (
            <p>
              {course?.type === 'book'
                ? "You can read this book by buying it."
                : "You can enroll to this course by buying it."}
            </p>
          )}
          <div className="actions">
            <Link to={`/dashboard/cources/${courseId}/buy`}>
              <Button type="primary" icon={<ShoppingCartOutlined />}>
                {course?.type === 'book' ? "Buy This Book" : "Buy This Course"}
              </Button>
            </Link>

            {!isCourseInWishList() && (
              <Button
                type="default"
                icon={<HeartOutlined />}
                onClick={handleAddToWishList}
              >
                Add to Wishlist
              </Button>
            )}
            {course?.whatsappGroupLink && (
              <a
                href={course?.whatsappGroupLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  type="primary"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#25d366",
                  }}
                >
                  <WhatsAppOutlined />
                  Join Whatsapp Group
                </Button>
              </a>
            )}

            <Button
              type="link"
              onClick={() => setShowEntrollPopupForPaidCources(false)}
              style={{
                padding: 0,
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title="Assign Coordinator"
        open={showAssignModal}
        onOk={handleAssignCoordinator}
        confirmLoading={isAssigning}
        onCancel={() => setShowAssignModal(false)}
        okText="Assign"
        cancelText="Cancel"
        destroyOnClose
      >
        <div style={{ padding: "16px 0" }}>
          <p style={{ marginBottom: "8px" }}>Select a coordinator to assign to this course:</p>
          <Select
            placeholder="Select Coordinator"
            style={{ width: "100%" }}
            value={selectedCoordinatorId}
            onChange={(val) => setSelectedCoordinatorId(val)}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {coordinators.map((coord) => (
              <Select.Option key={coord.id} value={coord.id}>
                {coord.name} ({coord.email})
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>

      <Spin spinning={isLoading} tip="Loading..." size="large">
        <div className="course-continer">
          <div className="course-header">
            <div className="about-course">
              <div className="title-flex">
                <h1 className="course-title">{course?.name}</h1>
                {course?.type !== 'book' && (
                  <span className="course-duration-header-badge">
                    ⏱️ {totalDuration}
                  </span>
                )}
              </div>

              <div
                className="course-description ql-editor"
                style={{ padding: 0 }}
                dangerouslySetInnerHTML={{ __html: course?.description }}
              />
            </div>
            <div className="">
              <div className="course-header-right">
                {course?.whatsappGroupLink && (
                  <div className="whatsapp-group">
                    {/* <h3>Join Our Whatsapp Group</h3> */}
                    <a
                      href={course?.whatsappGroupLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        type="primary"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#25d366",
                        }}
                      >
                        <WhatsAppOutlined />
                        Join Whatsapp Group
                      </Button>
                    </a>
                  </div>
                )}
                {userProfile?.role === "student" && !isCourseInUserCourses && (
                  <Link to={`/dashboard/cources/${courseId}/buy`}>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      icon={<ShoppingCartOutlined />}
                      style={{
                        // marginTop: "60px",
                        height: "32px",
                      }}
                    >
                      {course?.type === 'book' ? (course?.price === 0 ? "Get This Book" : "Buy This Book") : "Buy This Course"}
                    </Button>
                  </Link>
                )}
                {isSuperAdmin && (
                  <div className="admin-actions">
                    {isSuperAdmin && (
                      <Button
                        type="default"
                        className="btn"
                        onClick={() => setOpenCourseUsers(true)}
                      >
                        <span>{courseUsers?.length}</span>
                        {isLoadingUsers ? <LoadingOutlined /> : <UserOutlined />}
                        <span>Users</span>
                      </Button>
                    )}

                    {(userProfile?.role === "superadmin" || userProfile?.role === "admin") && (
                      <Button
                        type="default"
                        className="btn"
                        onClick={() => {
                          setSelectedCoordinatorId(course?.coordinatorId || undefined);
                          setShowAssignModal(true);
                        }}
                      >
                        <UserOutlined />
                        <span>Assign Coordinator</span>
                      </Button>
                    )}

                    {(userProfile?.role === "superadmin" || userProfile?.role === "admin" || isCoordinator) && (
                      <Link to={`/dashboard/cources/${courseId}/edit`}>
                        <Button type="primary" className="btn">
                          <EditOutlined />
                          <span>{course?.type === 'book' ? "Edit Book" : "Edit Course"}</span>
                        </Button>
                      </Link>
                    )}
                  </div>
                )}
              </div>

              {course?.type !== 'book' && (
                <div className="progress">
                  <h2>
                    <p>Your Study Progress</p>
                    <span>
                      {userProfile?.role === "student"
                        ? completedPercentage + "%"
                        : "100%"}
                    </span>
                  </h2>
                  <div className="progress-bar">
                    <Progress
                      percent={
                        userProfile?.role === "student"
                          ? completedPercentage
                          : 100
                      }
                      status="active"
                      strokeColor={{
                        from: "#108ee9",
                        to: "#87d068",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* <div className='strat-date-and-time'>
                        {course?.startDate &&
                            <div className='course-start'>
                                <h2>Course Start Date</h2>
                                <p>{course?.startDate}</p>
                            </div>
                        }

                        {course?.startTime &&
                            <div className='course-start'>
                                <h2>Start Time:</h2>
                                <p>{course?.startTime}</p>
                            </div>
                        }
                    </div>

                    {
                        course?.videoUrl &&
                        <div className='description-video'>
                            <Plyr
                                source={{
                                    type: "video",
                                    sources: [
                                        {
                                            src: course?.videoUrl,
                                            provider: "youtube"
                                        }
                                    ],
                                }}
                            />
                        </div>
                    } */}

          <Divider />

          {course?.type === 'book' ? (
            hasBookAccess ? (
              <div className="book-reader-wrapper" style={{ width: '100%', minHeight: '80vh', marginTop: '20px' }}>
                {course?.pdfUrl ? (
                  <BookReader pdfUrl={course.pdfUrl} bookTitle={course.name} />
                ) : (
                  <div className="no-data">
                    <img src={nodata} alt="No PDF" />
                    <h1>PDF File Will be Available Soon</h1>
                  </div>
                )}
              </div>
            ) : (
              <div className="buy-course-error" style={{ width: '100%', padding: '40px', textAlign: 'center' }}>
                <h1>You need to purchase this book to read it</h1>
                <img src={buyImage} alt="Buy Book" style={{ maxWidth: '300px', margin: '20px auto', display: 'block' }} />
                <div style={{ marginTop: '20px' }}>
                  <Link to={`/dashboard/cources/${courseId}/buy`}>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      icon={<ShoppingCartOutlined />}
                    >
                      {course?.price === 0 || course?.price === "0" ? "Get Book" : "Buy This Book"}
                    </Button>
                  </Link>
                </div>
              </div>
            )
          ) : isLoading || !courseContents?.length ? (
            <div className="no-data">
              {!isLoading && (
                <div>
                  <img src={nodata} alt="No Data" />
                  <h1>Course Content Will be Available Soon</h1>
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="body">
                <div className="course-left">
                  {isContentUnlocked ? (
                    <span>
                      {(() => {
                        const selectedContent = courseContents?.find(
                          (item) => item.id === selectedContentId
                        );
                        if (!selectedContent)
                          return <h1>No video available</h1>;

                        let videoURL = selectedContent?.videoUrl;
                        let zoomURL = selectedContent?.zoomUrl;
                        let pdfURL = selectedContent?.pdfUrl;

                        // Always return a container with a stable key
                        return (
                          <div key={`content-container-${selectedContent.id}`}>
                            {pdfURL ? (
                              <div className="book-reader-wrapper" style={{ width: '100%', minHeight: '600px', borderRadius: '8px', overflow: 'hidden' }}>
                                <BookReader pdfUrl={pdfURL} bookTitle={selectedContent.title} />
                              </div>
                            ) : videoURL ? (
                              <Plyr
                                source={{
                                  type: "video",
                                  sources: [
                                    {
                                      src: videoURL,
                                      provider: "youtube",
                                    },
                                  ],
                                }}
                              />
                            ) : zoomURL ? (
                              <div className="zoom-recording-wrapper">
                                <iframe
                                  src={zoomURL}
                                  className="zoom-iframe"
                                  title="Zoom Recording"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                  style={{
                                    width: "100%",
                                    height: "600px",
                                    minHeight: "600px",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="no-data-mini">
                                {!isLoading && (
                                  <div>
                                    <img src={video} alt="No Data" />
                                    <h1>Video Will be Available Soon</h1>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })()}
                      {userProfile?.role === "superadmin" && (
                        <div
                          className="course-footer"
                          style={{ marginTop: "24px" }}
                        ></div>
                      )}

                      {userProfile?.role === "admin" && (
                        <div
                          className="course-footer"
                          style={{ marginTop: "24px" }}
                        ></div>
                      )}

                      <div className="active-lesson-header">
                        <div className="lesson-info">
                          <h2 className="active-lesson-title">
                            {(() => {
                              const selectedContent = courseContents?.find(
                                (item) => item.id === selectedContentId
                              );
                              return selectedContent ? selectedContent.title : "";
                            })()}
                          </h2>

                        </div>

                        {userProfile?.role === "student" && (
                          <div className="lesson-action">
                            <Button
                              loading={isEnrollLoading}
                              type="primary"
                              size="large"
                              onClick={handleMarkAsLearned}
                              className={
                                courseContents?.find(
                                  (item) => item.id === selectedContentId
                                )?.participation?.id
                                  ? "completed"
                                  : ""
                              }
                              disabled={
                                courseContents?.find(
                                  (item) => item.id === selectedContentId
                                )?.participation?.id
                              }
                            >
                              {courseContents?.find(
                                (item) => item.id === selectedContentId
                              )?.participation?.id
                                ? "Completed"
                                : "Mark As Completed"}
                            </Button>
                          </div>
                        )}
                      </div>

                      <div className="course-meta">
                        <h2 className="description">
                          ⏱️ Lesson Duration: {
                            courseContents?.find(
                              (item) => item.id === selectedContentId
                            )?.duration || "0 mins"
                          }
                        </h2>
                        <h2 className="description">
                          ⭐ Ratings: 4.8
                        </h2>
                        <h2 className="description">
                          📝 Certified Students: 1000+
                          {course?.totalStudents}
                        </h2>
                      </div>
                    </span>
                  ) : (
                    <div className="buy-course-error">
                      <h1>Pay the next installment to access this content</h1>
                      <img src={buyImage} alt="Buy Course" />
                      <Link to={`/dashboard/cources/${courseId}/buy`}>
                        <Button
                          type="primary"
                          size="large"
                          shape="round"
                          icon={<ShoppingCartOutlined />}
                        >
                          Buy This Course
                        </Button>
                      </Link>
                    </div>
                  )}
                </div>

                <div className="course-right">
                  <div className="course-content">
                    <h2>Course Contents</h2>
                    <div className="playlist-container">
                      <List
                        size="small"
                        bordered
                        dataSource={data}
                        renderItem={(item) => (
                          <List.Item
                            className={`${selectedContentId === item.id ? "active" : ""
                              } ${isContentLockedForUser(item.id) ? "locked" : ""
                              }`}
                            onClick={() =>
                              handleContentSelect(
                                item.id,
                                isContentLockedForUser(item.id)
                              )
                            }
                          >
                            <div className="btn" type="link">
                              {selectedContentId === item.id ? (
                                <PauseRoundedIcon
                                  style={{
                                    fontSize: "2rem",
                                    color: "#673bf9",
                                  }}
                                />
                              ) : (
                                <PlayArrowRoundedIcon
                                  style={{
                                    fontSize: "2rem",
                                    color: "#673bf9",
                                  }}
                                />
                              )}
                            </div>
                            <div className="course-content-item">
                              <Tooltip title={item.title} placement="topLeft">
                                <p>{item.title}</p>
                              </Tooltip>
                              <span>{item.duration}</span>
                            </div>
                            <div className="status">
                              {item?.status === "completed" ? (
                                <div className="icon">
                                  <CheckRoundedIcon
                                    style={{
                                      fontSize: "1.2rem",
                                      color: "#fff",
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="icon not">
                                  <CheckRoundedIcon
                                    style={{
                                      fontSize: "1.2rem",
                                      color: "#fff",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </List.Item>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <Divider style={{ margin: "30px 0" }} />

              {isContentUnlocked && (
                <div className="course-tabs-wrapper" style={{ width: '100%', marginTop: '35px', padding: '20px 0' }}>
                  <Tabs
                    defaultActiveKey="overview"
                    items={[
                      {
                        key: "overview",
                        label: "Overview",
                        className: "overview-tab",
                        icon: <BookOpen size={18} />,
                        children: (
                          <div
                            className="lesson-description ql-editor"
                            style={{ padding: 0 }}
                            dangerouslySetInnerHTML={{
                              __html: (() => {
                                const selectedContent =
                                  courseContents?.find(
                                    (item) => item.id === selectedContentId
                                  );

                                  if (!selectedContent) return "";

                                  return selectedContent.description;
                                })()
                              }}
                            />
                        ),
                      },

                      {
                        key: "learning-tools",
                        label: "Course Materials",
                        icon: <FolderOpen size={18} />,
                        children: (
                          <>
                            <h2>Course Materials</h2>
                            <div className="drive-floder">
                              {(() => {
                                const selectedContent =
                                  courseContents?.find(
                                    (item) => item.id === selectedContentId
                                  );
                                if (!selectedContent)
                                  return <h1>No Drive Folder available</h1>;

                                let driveURL = selectedContent?.driveUrl;

                                return driveURL ? (
                                  <iframe
                                    className="drive-iframe"
                                    title="Google Drive Folder"
                                    src={driveURL}
                                  ></iframe>
                                ) : (
                                  <div className="no-data-mini">
                                    {!isLoading && (
                                      <div>
                                        <img src={files} alt="No Data" />
                                        <h1>
                                          Files Will be Available Soon
                                        </h1>
                                      </div>
                                    )}
                                  </div>
                                );
                              })()}
                            </div>
                          </>
                        ),
                      },
                      {
                        key: "assessments",
                        label: "Assessments",
                        icon: <ClipboardList size={18} />,
                        children: (
                          <CourseAssessments courseId={courseId} course={course} />
                        ),
                      },
                      {
                        key: "reviews",
                        label: "Reviews",
                        icon: <Star size={18} />,
                        children: (
                          <>
                            <div>Reviews will be available soon.</div>
                          </>
                        ),
                      },
                    ]}
                  />
                </div>
              )}


            </>
          )}
        </div>
      </Spin>

      <Modal
        title=""
        footer={null}
        centered
        open={showLockedContentPrompt}
        onCancel={() => setShowLockedContentPrompt(false)}
      >
        <div className="buy-course-error">
          <h1>
            {course?.price === 0 || course?.price === "0"
              ? "Enroll in this course to access this content"
              : userCources?.find((uc) => uc.courseId === courseId)
                ? "Pay the next installment to access this content"
                : "Enroll in this course to access this content"}
          </h1>
          <img src={buyImage} alt="Buy Course" />
          <Link to={`/dashboard/cources/${courseId}/buy`}>
            <Button
              type="primary"
              size="large"
              shape="round"
              icon={<ShoppingCartOutlined />}
            >
              {course?.price === 0 || course?.price === "0"
                ? "Enroll Now"
                : "Buy This Course"}
            </Button>
          </Link>
        </div>
      </Modal>

      <CourseUsers
        openCourseUsers={openCourseUsers}
        setOpenCourseUsers={setOpenCourseUsers}
        getCourseUsers={getCourseUsers}
        courseId={courseId}
        courseUsers={courseUsers}
        course={course}
      />
    </div>
  );
};

export default Course;
